import { createModule } from '@/store/createModule';
import { IAgreement } from '@/models';


export const agreement = createModule<IAgreement>('agreement', {
  actions: {
    pushMessage({ commit }, payload) {
      commit('pushMessage', payload);
    }
  },
  mutations: {
    pushMessage(state, payload) {
      const item = Object.values(state.entities).find(({ id }) => id === payload.id)
      item?.chat?.messages.push(payload.data)
    }
  }
});